<template>
  <div class="footer-secondary-menu">
    <template v-if="menus.length">
      <is-link
        v-for="(menu, index) in menus"
        :href="menu.url"
        :is_link="menu.url !== location_pathname"
        :key="menu.title"
        class="footer-secondary-menu_item">
        <get-menu-title
          :default_title="menu.title+index"
          :title_array="menu.titles || []"/>
      </is-link>
    </template>
  </div>
</template>

<script>
import GetMenuTitle from "../../small_parts/GetMenuTitle.vue";
import {ssr_window} from "../../../helpers/ssr";
import IsLink from "../../slots/IsLink.vue";

export default {
  name: "FooterSecondaryMenu",
  components: {IsLink, GetMenuTitle},
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    location_pathname() {
      return ssr_window.location.pathname
    }
  },
}
</script>
